import * as yup from "yup";
export const duplicateEmailMess = "The email has already been taken.";
export const duplicateNameMess = "The name has already been taken.";
export const emailSchema = yup.string().matches(/^[a-zA-Z0-9_+%.-]+@[A-Za-z0-9]+\.[a-zA-Z]{2,}$/, "invalid email");
export const nameSchema = yup
  .string()
  .notRequired()
  .min(3)
  .max(15)
  .matches(/^[a-zA-Z0-9._]+$/, "Name must only contain letters, numbers, dots, and underscores");
export const passwordSchema = yup.string().min(8);
